<!-- PAGE CONTENT WRAPPER -->
<div class="page-content-wrap">
  <!-- Contenet page started-->
  <div class="row">
    <div [hidden]="pgLoad">
      <div class="adjust loader-container">
        <div class="loader2"></div>
      </div>
    </div>
    <div class="col-md-12" [hidden]="!pgLoad">
      <div class="aqu-table-heading">

      </div>
      <!-- breadcrumb -->
      <div [hidden]="!pgLoad" class="row">
        <div class="col-xs-12 col-md-6">
          <ul class="breadcrumb">
            <li><a routerLink="/home">Summary View</a></li>
            <li><a>Stocking List</a></li>
          </ul>
        </div>
      </div>
      <!-- breadcrumb End -->
      <!-- START BASIC TABLE SAMPLE -->
      <div class="panel panel-default" [hidden]="!pgLoad">
        <div class="search_cum_icons_button_container">
          <div class="search-div">
            <img src="../../../../../assets/images/New_Icons/search-icon.svg">
            <input type="text" (keyup)="searchStockingList()" [(ngModel)]="search"
                   name="search" autocomplete="off" placeholder="Search by section name, Pond name">
          </div>
        </div>
        <div class="panel-body table-responsive">
          <table class="table table-striped table-hover" id="dataTables-example" [hidden]="!pgLoad">
            <thead>
            <tr>
              <th>S.No</th>
              <th class="handSymbol" (click)="sortingTanks('farm')">FARM NAME
                <span class="glyphicon sort-icon"
                      [ngClass]="{'glyphicon-chevron-up':pondfarmAsc,'glyphicon-chevron-down':!pondfarmAsc}"></span>
              </th>
              <th class="handSymbol" (click)="sortingTanks('locationname')">LOCATION
                <span class="glyphicon sort-icon"
                      [ngClass]="{'glyphicon-chevron-up':pondlocationnameAsc,'glyphicon-chevron-down':!pondlocationnameAsc}"></span>
              </th>
              <th class="handSymbol" (click)="sortingTanks('sectionname')">SECTION
                <span class="glyphicon sort-icon"
                      [ngClass]="{'glyphicon-chevron-up':pondsectionnameAsc,'glyphicon-chevron-down':!pondsectionnameAsc}"></span>
              </th>
              <th class="handSymbol" (click)="sortingTanks('pondname')">POND NAME
                <span class="glyphicon sort-icon"
                      [ngClass]="{'glyphicon-chevron-up':pondnameAsc,'glyphicon-chevron-down':!pondnameAsc}"></span>
              </th>
              <th>CULTURE START DATE</th>
              <th>STOCKING</th>
              <th>DOC (Days)</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr class="searchfun" *ngFor="let list of customerPonds; let i = index">
              <td>{{  i + 1 }}</td>
              <td>{{ list && list.FarmSiteDetails[0] && list.FarmSiteDetails[0].businessID && list.FarmSiteDetails[0].businessID.businessName }}</td>
              <td>{{ list.FarmSiteDetails[0].address.district + ',' + list.FarmSiteDetails[0].address.village }}</td>
              <td>{{ (list && list.PondSection && list.PondSection.section_name) ? (list && list.PondSection && list.PondSection.section_name) : '--' }}</td>
              <td>{{ list.name }}</td>
              <td>{{ ((list && list.PondCultureData[0] && list.PondCultureData[0].start_date) == null ? '--' : (list && list.PondCultureData[0] && list.PondCultureData[0].start_date  | date:"dd-MMM-yyyy")) }}</td>
              <td>{{ list && list.PondCultureData[0] && list.PondCultureData[0].stocking_count | currencyFormat }}</td>
              <td>{{ (((list && list.PondCultureData[0] && list.PondCultureData[0].start_date) == null || (list && list.PondCultureData[0] && list.PondCultureData[0].start_date) == '') ? '--' : (list && list.PondCultureData[0] && list.PondCultureData[0].start_date  | ageindays)) + 1 }}</td>
              <td>
                <button type="button" class="dashboard-view-button"
                        (click)="getAllTotalAbwfcrList(list, list.name)"><span class="icon"><img
                  src="../../../../../assets/images/New_Icons/view-icon.svg" width="20"></span>
                  <span class="text">View</span>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
          <div *ngIf="listLoader" class="loader-div">
            <div class="adjust">
              <div class="loader2 list-loader"></div>
            </div>
          </div>
          <p class="noDataFoundMessage" *ngIf="customerPonds && customerPonds.length == 0">No Data Available</p>
        </div>
      </div>
      <!-- END BASIC TABLE SAMPLE -->
      <div class="modal fade" id="myModal" role="dialog">
        <div class="modal-dialog modal-lg modal-xl">
          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" title="Close Popup" class="close" data-dismiss="modal">&times;</button>
              <h4 class="modal-title">{{ pondName }}</h4>
            </div>
            <div class="modal-body totalfarmermodelscrollbar" id="style-4">
              <div class="panel panel-default">
                <div class="panel-body table-responsive">
                  <table class="table table-hover">
                    <thead>
                    <tr>
                      <th>ABW</th>
                      <th>DOC</th>
                      <th>SURVIVAL RATE</th>
                      <th>TOTAL BIOMASS(Kgs)</th>
                      <th>TOTAL HARVEST COUNT</th>
                      <th>TOTAL CONSUMPTION(Kgs)</th>
                      <th>FCR</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <td>{{ feedlogs && feedlogs.abw }}</td>
                      <td>{{ feedlogs && feedlogs.doc }}</td>
                      <td>{{ feedlogs && feedlogs.survivalRate | currencyFormat }}</td>
                      <td>{{ (feedlogs && feedlogs.totalBiomass / 1000) | currencyFormat }}</td>
                      <td>{{ feedlogs && feedlogs.totalHarvestCount | currencyFormat }}</td>
                      <td>{{ (feedlogs && feedlogs.totalConsumption / 1000) | currencyFormat }}</td>
                      <td>{{ feedlogs && feedlogs.FCR | currencyFormat }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="modal-footer ambrolive-popup-close">
              <button class="center-block submitbtn" data-dismiss="modal"
                      type="submit"><img src="assets/images/New_Icons/close.svg">Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--  </div>
</div>-->
